export var ComponentName;
(function (ComponentName) {
    ComponentName["Accordion"] = "Accordion";
    ComponentName["AccordionItem"] = "AccordionItem";
    ComponentName["AccordionHeader"] = "AccordionHeader";
    ComponentName["AccordionBody"] = "AccordionBody";
    ComponentName["AutoComplete"] = "AutoComplete";
    ComponentName["AutoLayout"] = "AutoLayout";
    ComponentName["AutoLayoutWrapper"] = "AutoLayoutWrapper";
    ComponentName["StatusState"] = "StatusState";
    ComponentName["Badge"] = "Badge";
    ComponentName["BadgeTextDirection"] = "BadgeTextDirection";
    ComponentName["BadgeColor"] = "BadgeColor";
    ComponentName["Box"] = "Box";
    ComponentName["BoxMarkup"] = "BoxMarkup";
    ComponentName["BoxItem"] = "BoxItem";
    ComponentName["BoxItemSize"] = "BoxItemSize";
    ComponentName["BoxHeader"] = "BoxHeader";
    ComponentName["BoxContent"] = "BoxContent";
    ComponentName["BoxFooter"] = "BoxFooter";
    ComponentName["BoxTableContainer"] = "BoxTableContainer";
    ComponentName["Breadcrumb"] = "Breadcrumb";
    ComponentName["BreadcrumbItem"] = "BreadcrumbItem";
    ComponentName["Button"] = "Button";
    ComponentName["ButtonList"] = "ButtonList";
    ComponentName["ButtonVariant"] = "ButtonVariant";
    ComponentName["ButtonMarkup"] = "ButtonMarkup";
    ComponentName["ButtonType"] = "ButtonType";
    ComponentName["Card"] = "Card";
    ComponentName["CardImage"] = "CardImage";
    ComponentName["CardContent"] = "CardContent";
    ComponentName["CircleIcon"] = "CircleIcon";
    ComponentName["Checkbox"] = "Checkbox";
    ComponentName["CheckboxList"] = "CheckboxList";
    ComponentName["CheckboxTiles"] = "CheckboxTiles";
    ComponentName["CheckboxTile"] = "CheckboxTile";
    ComponentName["Columns"] = "Columns";
    ComponentName["Column"] = "Column";
    ComponentName["Container"] = "Container";
    ComponentName["ContentSize"] = "ContentSize";
    ComponentName["Countdown"] = "Countdown";
    ComponentName["Divider"] = "Divider";
    ComponentName["Fab"] = "Fab";
    ComponentName["Hero"] = "Hero";
    ComponentName["Icon"] = "Icon";
    ComponentName["Image"] = "Image";
    ComponentName["Input"] = "Input";
    ComponentName["InputType"] = "InputType";
    ComponentName["InputStatus"] = "InputStatus";
    ComponentName["InputKeyboardAppearance"] = "InputKeyboardAppearance";
    ComponentName["InputAutoCapitalize"] = "InputAutoCapitalize";
    ComponentName["InputAutoCompleteType"] = "InputAutoCompleteType";
    ComponentName["InputTextContentType"] = "InputTextContentType";
    ComponentName["InputKeyboardType"] = "InputKeyboardType";
    ComponentName["Link"] = "Link";
    ComponentName["List"] = "List";
    ComponentName["ListItem"] = "ListItem";
    ComponentName["ListItemDescription"] = "ListItemDescription";
    ComponentName["ListIconStatus"] = "ListIconStatus";
    ComponentName["Modal"] = "Modal";
    ComponentName["ModalBody"] = "ModalBody";
    ComponentName["ModalMarkup"] = "ModalMarkup";
    ComponentName["ModalFooter"] = "ModalFooter";
    ComponentName["ModalHeader"] = "ModalHeader";
    ComponentName["ModalCtaMarkup"] = "ModalCtaMarkup";
    ComponentName["Navbar"] = "Navbar";
    ComponentName["NavbarBrand"] = "NavbarBrand";
    ComponentName["NavbarDropdown"] = "NavbarDropdown";
    ComponentName["NavbarDropdownSection"] = "NavbarDropdownSection";
    ComponentName["NavbarItem"] = "NavbarItem";
    ComponentName["NavbarLinks"] = "NavbarLinks";
    ComponentName["NavbarLink"] = "NavbarLink";
    ComponentName["NavbarMenu"] = "NavbarMenu";
    ComponentName["NavbarStart"] = "NavbarStart";
    ComponentName["NavbarExtras"] = "NavbarExtras";
    ComponentName["NavbarEnd"] = "NavbarEnd";
    ComponentName["NavbarDivider"] = "NavbarDivider";
    ComponentName["NavbarAccordionItem"] = "NavbarAccordionItem";
    ComponentName["NavbarItemMarkup"] = "NavbarItemMarkup";
    ComponentName["Pagination"] = "Pagination";
    ComponentName["PlanPricingPlanPricePrice"] = "PlanPricingPlanPricePrice";
    ComponentName["Popover"] = "Popover";
    ComponentName["Price"] = "Price";
    ComponentName["PriceLevel"] = "PriceLevel";
    ComponentName["PriceVariant"] = "PriceVariant";
    ComponentName["PricingPlan"] = "PricingPlan";
    ComponentName["PricingPlanItem"] = "PricingPlanItem";
    ComponentName["PricingPlanItems"] = "PricingPlanItems";
    ComponentName["PricingPlanHeader"] = "PricingPlanHeader";
    ComponentName["PricingPlanProduct"] = "PricingPlanProduct";
    ComponentName["PricingPlanExtra"] = "PricingPlanExtra";
    ComponentName["PricingPlanFooter"] = "PricingPlanfooter";
    ComponentName["PricingPlanSticker"] = "PricingPlanSticker";
    ComponentName["PricingPlanPrice"] = "PricingPlanPrice";
    ComponentName["PricingTable"] = "PricingTable";
    ComponentName["PricingTableExtra"] = "PricingTableExtra";
    ComponentName["ProductTour"] = "ProductTour";
    ComponentName["Progress"] = "Progress";
    ComponentName["ProgressItem"] = "ProgressItem";
    ComponentName["ProgressRadial"] = "ProgressRadial";
    ComponentName["ProgressRadialItem"] = "ProgressRadialItem";
    ComponentName["Otp"] = "Otp";
    ComponentName["Radio"] = "Radio";
    ComponentName["RadioList"] = "RadioList";
    ComponentName["RadioTiles"] = "RadioTiles";
    ComponentName["RadioTile"] = "RadioTile";
    ComponentName["Rows"] = "Rows";
    ComponentName["Row"] = "Row";
    ComponentName["ScrollView"] = "ScrollView";
    ComponentName["Section"] = "Section";
    ComponentName["Select"] = "Select";
    ComponentName["SelectOption"] = "SelectOption";
    ComponentName["SelectorIOtem"] = "SelectorIOtem";
    ComponentName["Spacer"] = "Spacer";
    ComponentName["SpacerSize"] = "SpacerSize";
    ComponentName["StatusIcon"] = "StatusIcon";
    ComponentName["Stepper"] = "Stepper";
    ComponentName["StepperStep"] = "StepperStep";
    ComponentName["Step"] = "Step";
    ComponentName["StepperStepMarkup"] = "StepperStepMarkup";
    ComponentName["Sticker"] = "Sticker";
    ComponentName["StickerVariant"] = "StickerVariant";
    ComponentName["StickerMarkup"] = "StickerMarkup";
    ComponentName["Switch"] = "Switch";
    ComponentName["Table"] = "Table";
    ComponentName["TableHead"] = "TableHead";
    ComponentName["TableBody"] = "TableBody";
    ComponentName["TableTr"] = "TableTr";
    ComponentName["TableTh"] = "TableTh";
    ComponentName["TableTd"] = "TableTd";
    ComponentName["Tabs"] = "Tabs";
    ComponentName["Tab"] = "Tab";
    ComponentName["TabList"] = "TabList";
    ComponentName["TabPanel"] = "TabPanel";
    ComponentName["TabPanels"] = "TabPanels";
    ComponentName["Tag"] = "Tag";
    ComponentName["TagVariant"] = "TagVariant";
    ComponentName["TagList"] = "TagList";
    ComponentName["Text"] = "Text";
    ComponentName["TextIcon"] = "TextIcon";
    ComponentName["TextLevels"] = "TextLevels";
    ComponentName["TextMarkup"] = "TextMarkup";
    ComponentName["TextIconMarkup"] = "TextIconMarkup";
    ComponentName["Textarea"] = "Textarea";
    ComponentName["Timeline"] = "Timeline";
    ComponentName["TimelineItem"] = "TimelineItem";
    ComponentName["TimelineContent"] = "TimelineContent";
    ComponentName["TimelineMarker"] = "TimelineMarker";
    ComponentName["Title"] = "Title";
    ComponentName["ToasterProvider"] = "ToasterProvider";
    ComponentName["ToolbarSpace"] = "ToolbarSpace";
    ComponentName["ToolbarItem"] = "ToolbarItem";
    ComponentName["ToolbarGroup"] = "ToolbarGroup";
    ComponentName["View"] = "View";
    ComponentName["SenderEnum"] = "SenderEnum";
    ComponentName["SegmentControl"] = "SegmentControl";
    ComponentName["SegmentControlItem"] = "SegmentControlItem";
    ComponentName["Alert"] = "Alert";
    ComponentName["Chips"] = "Chips";
    ComponentName["ChipsList"] = "ChipsList";
    ComponentName["Range"] = "Range";
})(ComponentName || (ComponentName = {}));
//# sourceMappingURL=data:application/json;base64,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